module.exports = __webpack_public_path__ + "fonts/fa-regular-400.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-regular-400.woff2
// module id = 49
// module chunks = 0